import script from "./AddAiDetachedNoteForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAiDetachedNoteForm.vue?vue&type=script&setup=true&lang=js"

import "./AddAiDetachedNoteForm.vue?vue&type=style&index=0&id=275affa2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-275affa2"]])

export default __exports__